import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "./locales/en.json";
import fr from "./locales/fr.json";
import de from "./locales/de.json";
import lu from "./locales/lu.json";
import pt from "./locales/pt.json";
import nl from "./locales/nl.json";
import es from "./locales/es.json";
import it from "./locales/it.json";
import pl from "./locales/pl.json";
import zh from "./locales/zh.json";
import ar from "./locales/ar.json";
import ja from "./locales/ja.json";
import ko from "./locales/ko.json";

export const supportedLanguages = [
  "en", "fr", "de", "lu", "pt", "nl",
  "es", "it", "pl", "zh", "ar", "ja", "ko",
] as const;
export type SupportedLanguage = (typeof supportedLanguages)[number];

/** RTL languages — used by components to set dir="rtl" */
export const rtlLanguages: ReadonlySet<SupportedLanguage> = new Set(["ar"]);

const resources = {
  en: { translation: en },
  fr: { translation: fr },
  de: { translation: de },
  lu: { translation: lu },
  pt: { translation: pt },
  nl: { translation: nl },
  es: { translation: es },
  it: { translation: it },
  pl: { translation: pl },
  zh: { translation: zh },
  ar: { translation: ar },
  ja: { translation: ja },
  ko: { translation: ko },
};

/** Set dir attribute on <html> based on current language */
function applyDirection(lng: string) {
  const dir = rtlLanguages.has(lng as SupportedLanguage) ? "rtl" : "ltr";
  document.documentElement.dir = dir;
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "en",
    supportedLngs: supportedLanguages,
    detection: {
      order: ["querystring", "localStorage", "navigator", "htmlTag"],
      lookupQuerystring: "lang",
      lookupLocalStorage: "i18nextLng",
      caches: ["localStorage"],
    },
    interpolation: {
      escapeValue: false,
    },
  });

// Apply direction on init and on every language change
applyDirection(i18n.language);
i18n.on("languageChanged", applyDirection);

export default i18n;
